/* eslint-disable camelcase, no-undef */
import React from 'react';
import config from '../../config';
import rawMarkup from '../../util/rawMarkup';

const { APP_CONFIG_PROPERTY } = config;

export default class TvGuideTemplate extends React.Component {
  render() {
    return (
      <html>
        <head>
          <meta charSet="UTF-8"></meta>
          <meta name="viewport" content="width=device-width"></meta>
          <meta http-equiv="Referrer-Policy" content="no-referrer, strict-origin-when-cross-origin"></meta>
          <script src="https://code.jquery.com/jquery-1.7.min.js"></script>
          <link rel="stylesheet" href="https://fonts.google.com/selection?category=Serif&selection.family=Lato|PT+Serif:700|Roboto+Slab:700&stylecount=4&width=4" media="all"></link>
          <link href="https://fonts.googleapis.com/css?family=Martel+Sans:400,200,300,600,700,800,900&subset=latin,devanagari,latin-ext" rel="stylesheet"/>
          
          <script dangerouslySetInnerHTML={rawMarkup(`window['${APP_CONFIG_PROPERTY}']=${JSON.stringify(this.props.config)};`)}></script>
          <script src={__webpack_public_path__ + this.props.assetsMapper['tv-guide'].js}></script>
        </head>
        <body>
          <div data-ng-app="epgApp" data-epgapp-wrapper></div>
        </body>
      </html>
    );
  }
}

TvGuideTemplate.propTypes = {
  config: React.PropTypes.object,
  assetsMapper: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/component/TvGuide/TvGuideTemplate.jsx